"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _okFilled = _interopRequireDefault(require("@ux/icon/ok-filled"));
var _minus = _interopRequireDefault(require("@ux/icon/minus"));
var _plus = _interopRequireDefault(require("@ux/icon/plus"));
var _commonStyles = require("../styles/commonStyles");
var _carouselSkeleton = _interopRequireDefault(require("./carousel-skeleton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const accountTabsSkeletonCss = "az2vk8q";
const TrayItem = _ref => {
  let {
    idx
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'trayItem',
    key: `tray-item-${idx}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)('cardImage')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.nbaItemAnimatedBg, 'cardText')
  }));
};
TrayItem.propTypes = {
  idx: _propTypes.default.number
};
const trayItems = function () {
  let totalItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  return [...new Array(totalItem)].map((_, idx) => {
    return /*#__PURE__*/_react.default.createElement(TrayItem, {
      key: idx,
      idx: idx
    });
  });
};
const AccountTabsSkeleton = _ref2 => {
  let {
    hideCarousel = false,
    totalTrayItem = 2
  } = _ref2;
  const nbaItemColor = (0, _commonStyles.nbaItemColorRandomizer)();
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      '--randomized-color': nbaItemColor
    },
    className: (0, _core.cx)(accountTabsSkeletonCss)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'bodyContainer'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'accountTabsContainer'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'tab-item'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "active-tab-decor-left-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "active-tab-decor-left"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "tab-item-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)('cardImage')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.nbaItemAnimatedBg, 'cardText')
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "active-tab-decor-right-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "active-tab-decor-right"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'accountsTray'
  }, trayItems(totalTrayItem))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'nbaContainer'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'nbaSelector'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "nbaItem"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'iconContainer'
  }, /*#__PURE__*/_react.default.createElement(_okFilled.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "nbaItem mobileDisplay"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'nbaDisplay'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cardTextContainer"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.nbaItemAnimatedBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.nbaItemAnimatedBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)('cardImage')
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "nbaItem"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cardTextContainer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flexContainer"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'iconContainer'
  }, /*#__PURE__*/_react.default.createElement(_minus.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "otherContainer"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "cardTextContainer"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "tabletContainer"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'iconContainer'
  }, /*#__PURE__*/_react.default.createElement(_plus.default, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "nbaItem"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'iconContainer'
  }, /*#__PURE__*/_react.default.createElement(_plus.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "nbaItem"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'iconContainer'
  }, /*#__PURE__*/_react.default.createElement(_plus.default, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'nbaDisplay'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cardTextContainer"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.nbaItemAnimatedBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.nbaItemAnimatedBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)('cardImage')
  })))), !hideCarousel && /*#__PURE__*/_react.default.createElement(_carouselSkeleton.default, {
    className: "carouselSkeleton"
  })));
};
AccountTabsSkeleton.propTypes = {
  hideCarousel: _propTypes.default.bool,
  totalTrayItem: _propTypes.default.number
};
var _default = AccountTabsSkeleton;
exports.default = _default;